import React, { useState, useEffect } from "react";
import FullRouter from "./RouterPath/index";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./Assets/style/style.css";
import { BrowserRouter } from "react-router-dom"; // Keep BrowserRouter only here
import { GoogleOAuthProvider } from "@react-oauth/google";

// Add your Google OAuth Client ID here
// Get it from: https://console.cloud.google.com/apis/credentials
// const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "YOUR_GOOGLE_CLIENT_ID";
const GOOGLE_CLIENT_ID = "393877425666-o8ddqc94htm7q047r1m8j06n3v62v2m3.apps.googleusercontent.com";
 
function App() {
  

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <div>
        <BrowserRouter>
          <FullRouter />
        </BrowserRouter>
      </div>
    </GoogleOAuthProvider>
  );
}

export default App;
